import React, { useState } from "react";
import { Globe, Loader2, Check, Images } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { act } from "../../lib/sales";

// Vendors pull photos from their own website straight into their profile.
export function OnlinePhotos({ vendor, website, onAdded }) {
  const [list, setList] = useState(null);
  const [pick, setPick] = useState({});
  const [busy, setBusy] = useState("");
  async function find() {
    setBusy("find");
    const r = await act(() => api.post(`/vendors/${vendor.vendor_id}/photo-suggestions`, { website: website || vendor.website }));
    setBusy("");
    if (r) { setList(r.photos); setPick({}); }
  }
  async function add() {
    const urls = Object.keys(pick).filter((k) => pick[k]);
    if (!urls.length) return;
    setBusy("add");
    const r = await act(() => api.post(`/vendors/${vendor.vendor_id}/photos/import`, { urls }), "Photos added to your profile");
    setBusy("");
    if (r) { setList(null); onAdded(); }
  }
  async function google() {
    setBusy("google");
    const r = await act(() => api.post(`/vendors/${vendor.vendor_id}/google-photos`));
    setBusy("");
    if (r) { toast.success(r.added ? `${r.added} photos added from your Google listing` : "No new photos on your Google listing"); if (r.added) onAdded(); }
  }
  return (
    <div className="mt-4 border-t border-[var(--line)] pt-4" data-testid="online-photos">
      <div className="flex items-center gap-3 flex-wrap">
        <button type="button" onClick={find} disabled={!!busy} className="btn-outline-gold text-xs py-2" data-testid="online-photos-find">{busy === "find" ? <Loader2 className="w-3 h-3 animate-spin" /> : <Globe className="w-3 h-3" />} Find my photos online</button>
        <button type="button" onClick={google} disabled={!!busy} className="btn-outline-gold text-xs py-2" data-testid="online-photos-google">{busy === "google" ? <Loader2 className="w-3 h-3 animate-spin" /> : <Images className="w-3 h-3" />} Add all my Google photos</button>
        <p className="text-xs text-[var(--muted)]">Pull photos from your own website or your Google business listing. Only add photos you have the rights to use.</p>
      </div>
      {list && <>
        <div className="grid grid-cols-3 md:grid-cols-6 gap-2 mt-3">{list.map((p) => <button type="button" key={p.url} onClick={() => setPick({ ...pick, [p.url]: !pick[p.url] })} className={`relative rounded-lg overflow-hidden border-2 ${pick[p.url] ? "border-[var(--gold)]" : "border-transparent"}`} data-testid="online-photo-option">
          <img src={p.url} alt={p.alt} className="aspect-square object-cover w-full" loading="lazy" />{pick[p.url] && <span className="absolute top-1 right-1 bg-[var(--gold)] rounded-full p-0.5"><Check className="w-3 h-3 text-white" /></span>}</button>)}</div>
        {!list.length && <p className="text-sm text-[var(--muted)] mt-3">We couldn't find photos on your website. Upload them instead.</p>}
        {list.length > 0 && <button type="button" onClick={add} disabled={!!busy || !Object.values(pick).some(Boolean)} className="btn-gold text-xs mt-3 disabled:opacity-40" data-testid="online-photos-add">{busy === "add" ? "Adding…" : `Add ${Object.values(pick).filter(Boolean).length} photo(s)`}</button>}
      </>}
    </div>
  );
}
